// components/LoadErrorPanel.jsx
// What a page shows when a read it depends on did not come back.
//
// The point is what it does NOT show. These pages decide about ownership, so a
// failed read cannot be allowed to look like an answer: no buy button, no price,
// no locked overlay, no redirect. Just what happened and a way to try again.
//
// The caller supplies its own chrome (Navbar and background), because these
// pages do not share a palette.

const LoadErrorPanel = ({
  title = "We could not load this page",
  message = "Something went wrong reaching the server. Your account and anything you have bought are unaffected.",
  onRetry,
  retrying = false,
  background = "#F5F2EC",
  accent = "#2563EB",
  ink = "#1a1a2e",
  muted = "#6B6458",
}) => (
  <div
    role="alert"
    style={{
      background,
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      padding: "2rem 1.5rem",
      fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif",
    }}
  >
    <div style={{ maxWidth: 440, textAlign: "center" }}>
      <div
        aria-hidden="true"
        style={{
          width: 52,
          height: 52,
          borderRadius: "50%",
          background: "#FEF3C7",
          border: "1px solid #FDE68A",
          display: "grid",
          placeItems: "center",
          margin: "0 auto 18px",
        }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        </svg>
      </div>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: ink, margin: "0 0 10px" }}>
        {title}
      </h2>
      <p style={{ fontSize: 14.5, lineHeight: 1.6, color: muted, margin: "0 0 22px" }}>
        {message}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          disabled={retrying}
          style={{
            background: accent,
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "11px 22px",
            fontSize: 14,
            fontWeight: 600,
            cursor: retrying ? "default" : "pointer",
            opacity: retrying ? 0.6 : 1,
            fontFamily: "inherit",
          }}
        >
          {retrying ? "Retrying..." : "Try again"}
        </button>
      )}
    </div>
  </div>
);

export default LoadErrorPanel;
